import { render, staticRenderFns } from "./Fidelisation.vue?vue&type=template&id=8c244cfa"
import script from "./Fidelisation.vue?vue&type=script&lang=js"
export * from "./Fidelisation.vue?vue&type=script&lang=js"
import style0 from "./Fidelisation.vue?vue&type=style&index=0&id=8c244cfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports